import React from 'react'
import { MdClose } from 'react-icons/md'
import ATStepper from '../../../common/appStepper/ATStepper'
import ATHeaderText from '../../../common/headerText/ATHeaderText'
import ATIconButton from '../../../common/formComponent/ATIconButton'
import AddUserDetails from './AddUserDetails'
import { useTranslation } from 'react-i18next'
import AddUserRoles from './AddUserRoles'
import { userSteps } from '../../userManagementConstants'
import useUserManagement from '../../../../customHooks/usermanagement/useUserManagement'
import AddCustomerRoles from './AddCustomerRoles'
import { useAddUserDetailsHooks } from '../../../../customHooks/usermanagement/useAddUserDetailsHooks'

interface AddUserPopupProps {
  onCloseModal: () => void
  isEdit: boolean
  userId?: string
}

const AddUserPopup = ({ onCloseModal, isEdit, userId }: AddUserPopupProps) => {
  const { t } = useTranslation(['translation'])
  const { userRolesData, AppTypesWithRoles } = useAddUserDetailsHooks()
  const { backButtonHandler, continueButtonHandler, activeStep } =
    useUserManagement()
  const getComponentConditionally = () => {
    switch (activeStep) {
      case 0:
        return (
          <AddUserDetails
            initialValues={userRolesData}
            continueButtonHandler={continueButtonHandler}
            onCloseModal={onCloseModal}
            isEdit={isEdit}
          />
        )
      case 1:
        return (
          <AddUserRoles
            backButtonHandler={backButtonHandler}
            continueButtonHandler={continueButtonHandler}
            onCloseModal={onCloseModal}
            getRoleList={AppTypesWithRoles?.data}
            isEdit={isEdit}
            userId={userId}
          />
        )
      case 2:
        return (
          <AddCustomerRoles
            backButtonHandler={backButtonHandler}
            onCloseModal={onCloseModal}
            getRoleList={AppTypesWithRoles?.data}
            isEdit={isEdit}
            userId={userId}
            continueButtonHandler={continueButtonHandler}
          />
        )
      default:
        return null
    }
  }
  return (
    <div className="add-hauler-modal-content">
      <ATHeaderText
        title={isEdit ? t('userRoles.edit_user') : t('userRoles.add_user')}
      >
        <ATIconButton
          icon={<MdClose size={18} className="text-dark" />}
          onClick={onCloseModal}
          variant="link"
        />
      </ATHeaderText>
      <div className="px-4 py-2">
        <ATStepper steps={userSteps} activeStep={activeStep} />
      </div>
      <div>{getComponentConditionally()}</div>
    </div>
  )
}

export default AddUserPopup
